/* eslint-disable */
import Query from '../../components/Report';

const query = ({ offset = 0, limit = 1000, id_place = 0 }) => {
    const id = id_place ? Number(id_place) + 2 : '';
    return new Query('article-id-performance', { offset, limit, safe_offset: id });
};
export const getAllQuery = () => new Query('discover-domains-top-pages-all');

export default query;

export const saveArticleIdPlace = (domain_id, id_place) => {
    return fetch(`/api/v1/domains/config/${domain_id}/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify({ article_id_position: id_place }),
    });
};

export const getArticleIdPlace = (domain_id) => {
    return fetch(`/api/v1/domains/config/${domain_id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
